<template>
    <content-layout>
        <h1 slot="header">Lapas karte</h1>

        <div class="row page-container">
            <div class="column small-12 large-8">
                <div class="page">
                    <div v-for="node in categories">
                        <h2><router-link :to="{ name: 'category', params: { 'categoryNodeId': node.id } }">{{ node.category.title }}</router-link></h2>
                        <hr/>
                        <ul v-if="node.children.length > 0" class="row sitemap">
                            <li v-for="sub in node.children" class="small-12 medium-6 column">
                                <h3><router-link :to="{ name: 'category', params: { 'categoryNodeId': sub.id } }">{{ sub.category.title }}</router-link></h3>
                                <ul v-if="sub.children.length > 0" class="sitemap">
                                    <li v-for="sub2 in sub.children"><router-link :to="{ name: 'category', params: { 'categoryNodeId': sub2.id } }">{{ sub2.category.title }}</router-link></li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h2>Lapas</h2>
                        <hr/>
                        <ul class="row sitemap">
                            <li class="small-12 medium-6 column"><router-link :to="{ name: 'site-map' }"><h3>Lapas karte</h3></router-link></li>
                            <li class="small-12 medium-6 column"><router-link :to="{ name: 'contact' }"><h3>Sazinies</h3></router-link></li>
                            <li class="small-12 medium-6 column"><router-link :to="{ name: 'page', params: { slug: 'noteikumi' } }"><h3>Noteikumi</h3></router-link></li>
                            <li class="small-12 medium-6 column"><router-link :to="{ name: 'page', params: { slug: 'about' } }"><h3>Par portālu</h3></router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </content-layout>
</template>

<script>
    import ContentLayout from '../../layouts/ContentLayout'
    import { mapGetters } from 'vuex'

    export default {

        data() {
            return {

            }
        },

        created() {

            if (this.categories.length === 0) {
                this.$store.dispatch('getCategories');
            }

        },

        computed: {
            ...mapGetters(['categories'])
        },

        components: {
            ContentLayout
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .sitemap {
        @include reset-list;
        margin-bottom: $global-margin;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/pages/SiteMap.vue